import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { NavItem } from '../components/menu/navItem';

// NavService is an interface that defines the getter methods for the sidebar and header bar navigation items.
// The consuming application(s) must provide an implementation of this interface via the InjectionToken NAV_ITEM_SERVICE.
export interface NavItemService {
  getSidebarNavItems(): Observable<NavItem[]>;
  getHeaderBarNavItems(): Observable<NavItem[]>;
}

export const NAV_ITEM_SERVICE = new InjectionToken<NavItemService>('NavItemService');
